import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './index.module.less';

const Loading = ({ tip }: any) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 28 }} spin />;
  return (
    <div className={styles.loadingPage}>
      <div className={styles.loadingWrap}>
        <Spin indicator={antIcon} size="large" tip={tip} delay={100} />
      </div>
    </div>
  );
};

export default Loading;
